type BrowserLocationLike = Pick<Location, 'pathname' | 'search' | 'hash'>;

const LOGIN_PATH = '/login';
export const LOGIN_RETURN_PATH_QUERY_PARAM = 'returnPath';

export function buildReturnPathFromLocation(locationLike: BrowserLocationLike): string {
  return `${locationLike.pathname}${locationLike.search}${locationLike.hash}`;
}

export function getLoginPathWithReturnPath(returnPath: string): string {
  const params = new URLSearchParams({ [LOGIN_RETURN_PATH_QUERY_PARAM]: returnPath });
  return `${LOGIN_PATH}?${params.toString()}`;
}

export function getLoginPathForLocation(locationLike: BrowserLocationLike): string {
  return getLoginPathWithReturnPath(buildReturnPathFromLocation(locationLike));
}

export function parseLoginReturnPath(search: string): string | null {
  const params = new URLSearchParams(search);
  return sanitizeReturnPath(params.get(LOGIN_RETURN_PATH_QUERY_PARAM));
}

function sanitizeReturnPath(returnPath: string | null): string | null {
  if (!returnPath) {
    return null;
  }

  const trimmedReturnPath = returnPath.trim();
  if (trimmedReturnPath.length === 0) {
    return null;
  }

  if (!trimmedReturnPath.startsWith('/')) {
    return null;
  }

  if (trimmedReturnPath.startsWith('//')) {
    return null;
  }

  const pathname = trimmedReturnPath.split('#', 1)[0]?.split('?', 1)[0];
  if (pathname === LOGIN_PATH) {
    return null;
  }

  return trimmedReturnPath;
}
